module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.6fabf009.mp3";